export const Phone = ({ src, alt, className = "", testId }) => (
  <div
    data-testid={testId}
    className={`relative w-[250px] shrink-0 rounded-[2.6rem] bg-[#07080a] p-[9px] shadow-[0_40px_100px_-30px_rgba(0,0,0,0.9),0_0_0_1px_rgba(255,255,255,0.09)] ${className}`}
  >
    <div className="relative aspect-[921/1700] w-full overflow-hidden rounded-[2.1rem] bg-[#0e0f12] pt-7">
      <div className="absolute left-1/2 top-[8px] z-10 h-[18px] w-[72px] -translate-x-1/2 rounded-full bg-black" />
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-contain object-top" />
    </div>
  </div>
);
